import { Dialog, DialogProps } from "@mui/material";
import React from "react";
import { useAppSelector } from "~/redux/store/store";

type FileExplorerProps = {
  children: JSX.Element;
  props?: DialogProps;
};

export const useFileExplorerDialog = () => {
  const isMobile = useAppSelector((state) => state.general.isMobile);
  const [fileDialogOpen, setFileDialogOpen] = React.useState(false);
  const FileExplorerDialog = React.useCallback(
    ({ children, ...props }: FileExplorerProps) => {
      return (
        <Dialog
          open={fileDialogOpen}
          onClose={() => setFileDialogOpen(false)}
          maxWidth={false}
          fullScreen={isMobile}
          fullWidth
          PaperProps={{
            sx: {
              resize: "horizontal",
              width: {
                xs: "100%",
                sm: "100%",
                md: "90%",
                lg: "80%",
                xl: "70%",
              },
              minWidth: isMobile ? "auto" : "800px",
              margin: 0,
            },
          }}
          {...props}
        >
          {children}
        </Dialog>
      );
    },
    [fileDialogOpen, isMobile],
  );
  return {
    FileExplorerDialog,
    fileDialogOpen,
    setFileDialogOpen,
  };
};
